import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export const linkRequestsAdapter = createEntityAdapter({
  selectId: linkRequest => linkRequest._id,
});

const initialState = {
  data: {},
  linkRequests: linkRequestsAdapter.getInitialState(),
  myNutritionist: null,
  metadata: {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  }
};

const wnUserSlice = createSlice({
  name: 'wnUser',
  initialState,
  reducers: {
    setWnUserData: (state, action) => {
      state.data = action.payload;
    },
    setWnUserNutritionist: (state, action) => {
      state.myNutritionist = action.payload;
    },
    setUserLinkRequests: (state, action) => {
      linkRequestsAdapter.setAll(state.linkRequests, action.payload);
    },
  },
});

export const { setWnUserData, setWnUserNutritionist, setUserLinkRequests } =
  wnUserSlice.actions;

export const WnUserReducer = wnUserSlice.reducer;
